import { render, staticRenderFns } from "./TopBarHeader.vue?vue&type=template&id=0f5967bc&scoped=true"
import script from "./TopBarHeader.vue?vue&type=script&lang=js"
export * from "./TopBarHeader.vue?vue&type=script&lang=js"
import style0 from "./TopBarHeader.vue?vue&type=style&index=0&id=0f5967bc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5967bc",
  null
  
)

export default component.exports